__turbopack_context__.v({
  "centered": "page-module-scss-module__BXe9xG__centered",
  "container": "page-module-scss-module__BXe9xG__container",
  "content": "page-module-scss-module__BXe9xG__content",
  "desktopOnly": "page-module-scss-module__BXe9xG__desktopOnly",
  "memberDetail": "page-module-scss-module__BXe9xG__memberDetail",
  "memberDetail__container": "page-module-scss-module__BXe9xG__memberDetail__container",
  "memberDetail__irlContribution": "page-module-scss-module__BXe9xG__memberDetail__irlContribution",
  "singleColumn": "page-module-scss-module__BXe9xG__singleColumn",
});
